import BottomSheet from "../components/BottomSheet";
import { useEffect, useState } from "react";
import {useNavigate, useParams} from "react-router";
import { editInstruction } from "../util/PurchaseManager";

const ConfirmationModal = ({ showOrder, setShowOrder, removeFromCart, clear, editCart, refresh }) => {
    const [instructions, setInstructions] = useState(JSON.parse(localStorage.getItem("cart"))?.instructions ?? "");
    const [order, setOrder] = useState([]);
    const [sum, setSum] = useState(0);
    const [confirmClear, setConfirmClear] = useState(false)

    const {restaurant} = useParams();

    useEffect(() => {
        if (showOrder) {
            let storage = localStorage.getItem("cart") ?? {};

            try {
                storage = storage ? JSON.parse(storage) : {};
            } catch (error) {
                console.error("Error parsing localStorage cart:", error);
                storage = {};
            }

            setInstructions(storage?.instructions ?? "");
            setOrder(storage?.items ?? []);
            setSum(storage?.sum ?? 0);
        } else {
            editInstruction(instructions);
        }
    }, [showOrder, refresh]);

    const navigate = useNavigate();

    if(confirmClear){
        return (
            <BottomSheet
              showModal={confirmClear}
              setShowModal={setConfirmClear}
              saveAction={() => {
                clear();
                setShowOrder(false)
              }}
              showCancel={true}
              saveText="Rensa varukorg"
              headerText="Töm varukorg?"
            >
              <div className="text-center p-2">
                <p className="fs-5 mb-3">
                  Är du säker på att du vill tömma varukorgen? Denna åtgärd kan inte ångras.
                </p>
              </div>
            </BottomSheet>
          );
          
    }

    return (
        <BottomSheet
            showModal={showOrder}
            setShowModal={setShowOrder}
            headerText={"Bekräfta order"}
            saveText="Till betalning"
            saveAction={() => {
                editInstruction(instructions);
                navigate(`/${restaurant}/checkout`)
            }}
        >
            {
                order.length > 0 &&
                <div className="d-flex pb-3">
                    <button className="btn btn-outline-secondary" style={{marginLeft: "auto"}} onClick={()=>{setConfirmClear(true)}}>Rensa varukorg</button>
                </div>
            }
            
            <div className="container">
                {order.length === 0 ? (
                    <p className="text-center text-muted">Varukorgen är tom</p>
                ) : (
                    <div className="row">
                        {order.map((item, index) => (
                            <div key={index} className="col-12 mb-3">
                                <div className="d-flex align-items-center border rounded p-3 shadow-sm  ">
                                    {/* Product Image */}
                                    {item.image && (
                                        <img
                                            src={item.image}
                                            alt={item.text}
                                            className="rounded-circle me-3"
                                            style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                        />
                                    )}

                                    {/* Product Details */}
                                    <div className="flex-grow-1">
                                        <p className="mb-1 fw-bold">{item.text.toSwe()}</p>
                                        <p className="m-0 text-muted fw-semibold">{(item.finalPrice / 100).toFixed(2)} kr</p>

                                        {/* Customization Details */}
                                        {(item.customizations?.removed?.length > 0 ||
                                            item.customizations?.add_ons?.length > 0 ||
                                            item.pbo.plu00.p0fritxt) && (
                                            <div className="p-2   rounded">
                                                {/* Removed Ingredients */}
                                                {item.customizations?.removed?.length > 0 && (
                                                    <p className="m-0 text-danger fw-bold">
                                                        - <span className="fw-normal">
                                                            {item.customizations.removed
                                                                .map(id => {
                                                                    const ingredient = item.pbo?.iga?.find(ing => ing.p0lopnr === id);
                                                                    return ingredient ? ingredient.p0text.toSwe() : `Ingredient ${id}`;
                                                                })
                                                                .join(", ")}
                                                        </span>
                                                    </p>
                                                )}

                                                {/* Added Add-Ons */}
                                                {item.customizations?.add_ons?.length > 0 && (
                                                    <p className="m-0 text-success fw-bold">
                                                        + <span className="fw-normal">
                                                            {item.customizations.add_ons.map(addOn => addOn.m0text.toSwe()).join(", ")}
                                                        </span>
                                                    </p>
                                                )}
                                                {item.customizations?.sides?.length > 0 && (
                                                    <p className="m-0 text-success fw-bold">
                                                        + <span className="fw-normal">
                                                            {item.customizations.sides.map(addOn => addOn.m0text.toSwe()).join(", ")}
                                                        </span>
                                                    </p>
                                                )}

                                                {/* Special Requests */}
                                                {item.pbo.plu00.p0fritxt && (
                                                    <p className="m-0 text-muted">
                                                        <i>Info:</i> {item.pbo.plu00.p0fritxt}
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    {/* Edit & Remove Buttons */}
                                    <div>
                                        <i className="bi bi-pencil-square fs-5 text-muted mx-2" onClick={() => editCart(index)}></i>
                                        <i className="bi bi-trash3 fs-5 text-danger" onClick={() => removeFromCart(index)}></i>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* Order Information */}
                <div className="my-3">
                    <h6>Övrig information:</h6>
                    <textarea
                        className="form-control bg-light"
                        rows="2"
                        value={instructions}
                        onChange={(e) => setInstructions(e.target.value)}
                    ></textarea>
                </div>

                {/* Order Summary */}
                {order.length > 0 && (
                    <div className="mt-3">
                        <hr />
                        <h6 className="d-flex justify-content-between">
                            <span>Totalbelopp:</span>
                            <span className="fw-bold">{sum.toFixed(2)} kr</span>
                        </h6>
                    </div>
                )}
            </div>
        </BottomSheet>
    );
};

export default ConfirmationModal;
